
import Vue from 'vue'
import { makeSearch, setQuery } from '../store/actions';
import { ISearchHit, ITranslations } from '../store/state'
interface SearchBoxComputed {
	query?: string
    translations: ITranslations
}
interface SearchBoxMethods {
	makeSearch(e: Event): void
    clearQuery(): void
}

export default Vue.extend<{}, SearchBoxMethods, SearchBoxComputed, {}>({
	name: 'SearchBox',
	computed: {
        query: {
            get() {
                return this.$store.getters.query
            },
            set(value: string) {
                this.$store.dispatch(setQuery(value))
            }
        },
		translations() {
			return this.$store.getters.translations;
		}
    },
    methods: {
        makeSearch(e) {
            e.preventDefault();
            this.$store.dispatch(makeSearch(undefined))
        },
        clearQuery() {
            this.$store.dispatch(setQuery(''));
            (this.$refs.input as HTMLInputElement).focus()
        }
    }
})
